import React, { FunctionComponent } from 'react';

import { angularize } from 'react-in-angularjs';

import { SystemProviders } from '../SystemProviders/SystemProviders';

/**
 * Wraps React component with SystemProviders before angularizing it.
 * Use this instead of angularize for Ngz* components that need SystemProviders.
 * Automatically sets angular.module('app') as the Angular module.
 *
 * @param Component - React component to angularize
 * @param componentName - Angular component name (e.g., 'ngzResources')
 * @param bindings - Angular bindings configuration (e.g., { propName: '<' })
 */
export const angularizeWithProviders = <TProps extends object>(
  Component: FunctionComponent<TProps>,
  componentName: string,
  bindings: { [key in keyof TProps]: '<' | '=' | '@' | '&' },
) => {
  const WrappedComponent = (props: TProps) => {
    return (
      <SystemProviders>
        <Component {...props} />
      </SystemProviders>
    );
  };

  angularize(WrappedComponent, componentName, angular.module('app'), bindings);
};
